import { render, staticRenderFns } from "./ModalToko.vue?vue&type=template&id=2c11e8b8&scoped=true&"
import script from "./ModalToko.vue?vue&type=script&lang=js&"
export * from "./ModalToko.vue?vue&type=script&lang=js&"
import style0 from "./ModalToko.vue?vue&type=style&index=0&id=2c11e8b8&lang=scss&scoped=true&"
import style1 from "./ModalToko.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c11e8b8",
  null
  
)

export default component.exports